import { Message } from '../types'
import { prepareMessagesForAPI } from './messageHelpers'

interface ChatRequestBody {
  messages: Message[]
  noteContent: string | null
  selectedText: string | null
}

/**
 * Sends a chat request to the AI API.
 * Handles the initial message submission and returns the response.
 */
export async function sendChatRequest({
  messages,
  noteContent,
  selectedText,
}: ChatRequestBody): Promise<Response> {
  console.log('[apiClient] Fetching from /api/chat')

  const preparedMessages = prepareMessagesForAPI(messages)

  // Log image information for debugging
  const messagesWithImages = preparedMessages.filter(
    (msg) => msg.images && msg.images.length > 0
  )
  if (messagesWithImages.length > 0) {
    console.log(
      '[apiClient] Sending messages with images:',
      messagesWithImages.length
    )
    messagesWithImages.forEach((msg, index) => {
      console.log(
        `[apiClient] Message ${index + 1} has ${msg.images?.length} images`
      )
    })
  }

  const response = await fetch('/api/chat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      messages: preparedMessages,
      noteContent,
      selectedText,
    }),
  })

  console.log('[apiClient] Response status:', response.status)

  if (!response.ok) {
    const errorText = await response.text()
    console.error('[apiClient] API error response:', errorText)
    throw new Error(
      `HTTP error! status: ${response.status}, body: ${errorText}`
    )
  }

  return response
}

/**
 * Gets a reader from the response body for streaming.
 * Throws an error if no response body is available.
 */
export function getStreamReader(
  response: Response
): ReadableStreamDefaultReader<Uint8Array> {
  const reader = response.body?.getReader()
  if (!reader) {
    throw new Error('No response body')
  }
  return reader
}
